import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'grecoFilterBookingRequirementSubmissions' })
export class FilterBookingRequirementsPipe implements PipeTransform {
  transform(value: any[]) {
    return (value || []).filter(v => v?.form !== null);
  }
}
